// extracted by mini-css-extract-plugin
module.exports = {"nameInput":"ClaimModal_nameInput__3Altm","bioInput":"ClaimModal_bioInput__2XwxA","registerButton":"ClaimModal_registerButton__11vKP","modal":"ClaimModal_modal__3UNix"};